import { IApiResponse, INameExists, ICommonList } from 'src/app/Shared/interface';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import {
     IStorageFacilityListModel,  IMailServerSettingsModels, ILettersAndNoticeTemplateListModel, ILettersAndNoticesTemplateModel, ITemplateList, ILettersAndNoticesTemplateDataModel, IGeneratePrintLettes
} from '../Shared/interface2';
import { AppInsightsService } from './app-insights.service';
import { ILettersAndTemplatesObject, IQuestionnaires } from '../Shared/models/LettersAndTemplates';
import {AppService} from './app.service';


@Injectable({
    providedIn: 'root',
})

export class LetterAndNoticesService {
    private baseURL = this.appService.config.apiBaseUrl;
    public lettersAndNoticesId;
    public letterandnoticesTemplateId;
    public QuestionnairesList;

    private options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

    constructor(private http: HttpClient,
                private appinsights: AppInsightsService,
                private appService: AppService) { }

    getLettersAndNoticesList(): Observable<ILettersAndNoticeTemplateListModel[]> {
        return this.http.get<ILettersAndNoticeTemplateListModel[]>(
            `${this.baseURL}/LettersAndNotices/GetLettersAndNoticesList`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const MailServerList = res.body as ILettersAndNoticeTemplateListModel[];
                    return MailServerList;
                }),
                catchError(this.handleError)
            );
    }

    getLettersAndNoticesListForOp(): Observable<ILettersAndNoticeTemplateListModel[]> {
        return this.http.get<ILettersAndNoticeTemplateListModel[]>(
            `${this.baseURL}/LettersAndNotices/GetLettersAndNoticesListForOp`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const MailServerList = res.body as ILettersAndNoticeTemplateListModel[];
                    return MailServerList;
                }),
                catchError(this.handleError)
            );
    }

    getLettersAndNoticesById(Id: number): Observable<ILettersAndTemplatesObject> {
        return this.http.get<ILettersAndTemplatesObject>(
            `${this.baseURL}/LettersAndNotices/GetLettersAndNoticesById?id=${Id}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const StorageFacilityList = res.body as ILettersAndTemplatesObject;
                    return StorageFacilityList;
                }),
                catchError(this.handleError)
            );
    }

    getLettersAndNoticesByIdForOp(Id: number): Observable<ILettersAndTemplatesObject> {
        return this.http.get<ILettersAndTemplatesObject>(
            `${this.baseURL}/LettersAndNotices/GetLettersAndNoticesByIdForOp?id=${Id}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const StorageFacilityList = res.body as ILettersAndTemplatesObject;
                    return StorageFacilityList;
                }),
                catchError(this.handleError)
            );
    }

    getLettersAndNoticesNameExist(name: string): Observable<INameExists> {
        return this.http.get<INameExists>(
            `${this.baseURL}/LettersAndNotices/GetLettersAndNoticesNameExist?templateName=${name}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const StorageFacilityList = res.body as INameExists;
                    return StorageFacilityList;
                }),
                catchError(this.handleError)
            );
    }

    getLettersAndNoticesTemplateListByTypeId(id: number): Observable<ICommonList[]> {
        return this.http.get<ICommonList[]>(
            `${this.baseURL}/LettersAndNotices/GetLettersAndNoticesTemplateListByTypeId?typeId=${id}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const templateList = res.body as ICommonList[];
                    return templateList;
                }),
                catchError(this.handleError)
            );
    }

    getLettersAndNoticesTemplateListByTypeIdForOp(id: number): Observable<ICommonList[]> {
        return this.http.get<ICommonList[]>(
            `${this.baseURL}/LettersAndNotices/GetLettersAndNoticesTemplateListByTypeIdForOp?typeId=${id}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const templateList = res.body as ICommonList[];
                    return templateList;
                }),
                catchError(this.handleError)
            );
    }

        GetLettersAndNoticesTemplateListByTypeIdAndFacilityId(id: number,facilityId: number): Observable<ICommonList[]> {
        return this.http.get<ICommonList[]>(
            `${this.baseURL}/LettersAndNotices/GetLettersAndNoticesTemplateListByTypeIdAndFacilityId?typeId=${id}&facilityId=${facilityId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const templateList = res.body as ICommonList[];
                    return templateList;
                }),
                catchError(this.handleError)
            );
    }

    SaveLettersandNotice(lettersandNotice): Observable<IApiResponse> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }),};

        let url = '';
        if(lettersandNotice.Id === 0) {
            url = `${this.baseURL}/LettersAndNotices/CreateLettersandNotice`;
        } else {
            url = `${this.baseURL}/LettersAndNotices/UpdateLettersandNotice`;
        }
        return this.http.post<IApiResponse>(url, lettersandNotice, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    SaveQuestionnaires(Questionnaries): Observable<IApiResponse> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' })};
        let url = '';
        if(Questionnaries.Id === 0) {
            url = `${this.baseURL}/LettersAndNotices/SaveQuestionnaires`;
        } else {
            url = `${this.baseURL}/LettersAndNotices/SaveQuestionnaires`;
        }
        return this.http.post<IApiResponse>(url, Questionnaries, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    DeleteQuestionnaires(questionnairesId){
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' })};
        let url = `${this.baseURL}/LettersAndNotices/DeleteQuestionnaires?questionnairesId=${questionnairesId}`;
        return this.http.post<IApiResponse>(url, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    isQuestionExist(questionName, lettersAndNoticesId){
        return this.http.get<any>(
            `${this.baseURL}/LettersAndNotices/GetLetterQuestionExist?questionName=${questionName}&lettersAndNoticesId=${lettersAndNoticesId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                   return res.body as any;
                }),
                catchError(this.handleError)
            );
    }

    
    GetQuestionOptionExist(optionName, questionId){
        return this.http.get<any>(
            `${this.baseURL}/LettersAndNotices/GetQuestionOptionExist?optionName=${optionName}&questionsId=${questionId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                   return res.body as any;
                }),
                catchError(this.handleError)
            );
    }

    getLettersAndNoticesTemplateList(Id: number): Observable<ITemplateList> {
        return this.http.get<ITemplateList>(
            `${this.baseURL}/LettersAndNotices/GetLettersAndNoticesTemplateList?typeId=${Id}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const templateList = res.body as ITemplateList;
                    return templateList;
                }),
                catchError(this.handleError)
            );
    }

    GetEmailAndSMSMergeFieldsByTypeId(Id: number): Observable<any> {
        return this.http.get<any>(
            `${this.baseURL}/LettersAndNotices/GetEmailAndSMSMergeFieldsByTypeId?typeId=${Id}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const mergeFeildList = res.body as any;
                    return mergeFeildList;
                }),
                catchError(this.handleError)
            );
    }
    GetLettersAndNoticesTemplate(templateId: number): Observable<ILettersAndNoticesTemplateDataModel> {
      return this.http.get<ILettersAndNoticesTemplateDataModel>(
          `${this.baseURL}/LettersAndNotices/GetLettersAndNoticesTemplate?templateId=${templateId}`,
          { observe: 'response' })
          .pipe(
              map(res => {
                  const StorageFacilityList = res.body as ILettersAndNoticesTemplateDataModel;
                  return StorageFacilityList;
              }),
              catchError(this.handleError)
          );
  }

    getLettersAndNoticesTemplateText(templateId: number,typeId: number): Observable<ILettersAndNoticesTemplateModel> {
        return this.http.get<ILettersAndNoticesTemplateModel>(
            `${this.baseURL}/LettersAndNotices/GetLettersAndNoticesTemplateText?templateId=${templateId}&typeId=${typeId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const StorageFacilityList = res.body as ILettersAndNoticesTemplateModel;
                    return StorageFacilityList;
                }),
                catchError(this.handleError)
            );
    }

    deleteLetters(Id: number): Observable<IApiResponse> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        let url =  `${this.baseURL}/LettersAndNotices/DeleteLettersandNotices?id=${Id}`;
        return this.http.post<IApiResponse>(url, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    getLettersAndNoticesTransactionTypeList(): Observable<any[]> {
        return this.http.get<any[]>(
            `${this.baseURL}/LettersAndNotices/GetTransactionTypeListForLetters`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const transactionTypeList = res.body as any[];
                    return transactionTypeList;
                }),
                catchError(this.handleError)
            );
    }
    GetLettersAndNoticesAttachmentTemplate(transactionTypeId: number): Observable<any[]> {
        return this.http.get<any[]>(
            `${this.baseURL}/LettersAndNotices/GetAttachmentTemplateList?transactionTypeId=${transactionTypeId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const StorageFacilityList = res.body as any[];
                    return StorageFacilityList;
                }),
                catchError(this.handleError)
            );
    }

    GetActiveFacilitesListForTransactionType(transactionTypeId: number, type): Observable<any[]> {
        return this.http.get<any[]>(
            `${this.baseURL}/LettersAndNotices/GetActiveFacilityLettersAndNoticesByTransactionId?transactionId=${transactionTypeId}&typeId=${type}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const StorageFacilityList = res.body as any[];
                    return StorageFacilityList;
                }),
                catchError(this.handleError)
            );
    }
    GetActiveFacilitesListForbaseTemplate(baseTemplateId: number): Observable<any[]> {
        return this.http.get<any[]>(
            `${this.baseURL}/Store/GetActiveFacilityLettersAndNoticesByBaseTemplateId?baseTemplateId=${baseTemplateId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const StorageFacilityList = res.body as any[];
                    return StorageFacilityList;
                }),
                catchError(this.handleError)
            );
    }

    generateAndPrintLetters(generateLetterModel: IGeneratePrintLettes): Observable<any> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        let url =  `${this.baseURL}/EmailAndSMS/GenerateLettersAndSendEmail`;
        return this.http.post<any>(url, generateLetterModel, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    getRsignTemplateInfo(templateId): Observable<any[]> {
        return this.http.get<any[]>(
            `${this.baseURL}/LettersAndNotices/GetRsignTemplateInfo?templateId=${templateId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const transactionTypeList = res.body as any[];
                    return transactionTypeList;
                }),
                catchError(this.handleError)
            );
    }
  
    getRsignTemplateRuleList (): Observable<any[]> {
        return this.http.get<any[]>(
            `${this.baseURL}/LettersAndNotices/GetRsignTemplateRuleList`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const transactionTypeList = res.body as any[];
                    return transactionTypeList;
                }),
                catchError(this.handleError)
            );
    }

    eSignTemplateMergeFieldMappingsAdmin(lettersandNoticesId): Observable<any[]> {
        return this.http.get<any[]>(
            `${this.baseURL}/LettersAndNotices/ESignTemplateMergeFieldMappingsAdmin?LettersandNoticesId=${lettersandNoticesId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const transactionTypeList = res.body as any[];
                    return transactionTypeList;
                }),
                catchError(this.handleError)
            );
    }

    getQuestionnaires(lettersAndNoticesId: number, questionnairesId: number): Observable<IQuestionnaires[]> {
        return this.http.get<IQuestionnaires[]>(
            `${this.baseURL}/LettersAndNotices/GetQuestionnaires?lettersAndNoticesId=${lettersAndNoticesId}&questionnairesId=${questionnairesId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const questinnairesList = res.body as IQuestionnaires[];
                    return questinnairesList;
                }),
                catchError(this.handleError)
            );
    }

    private handleError(error: HttpErrorResponse) {
        console.error('server error:', error);
        if (error.error instanceof Error) {
            const errMessage = error.error.message;
            this.appinsights.logEvent(errMessage);
            return throwError(errMessage);
        }
        return throwError(error || 'Node.js server error');
    }

}
